import { createApiAction } from '@app/packages/api/utils'
import type { ApiComplaints } from '@app/packages/api/v2/types/entities'
import type { ComplaintRequest } from '@app/packages/api/v2/types/params'

export const postComplaints = (data: ComplaintRequest) =>
  createApiAction('postComplaints', dispatch =>
    dispatch<{ data: ApiComplaints }>({ method: 'POST', endpoint: '/api/v2/complaints', body: JSON.stringify(data) })
  )
